/// <amd-module name="Wit/UI/Behaviors/TitleClickFPS" />
import * as React from "react";
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssPageContext } from "VSS/Platform/Context";

export function createTitleClickFpsHandler(pageContext: IVssPageContext): ((e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, workItem: WorkItem) => boolean) {
    return (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, workItem: WorkItem): boolean => {
        const workItemUrl = workItem._links && workItem._links.html && workItem._links.html.href;

        const newTab = e.ctrlKey || e.metaKey;
        if (!newTab && pageContext && workItemUrl) {
            return !!onClickFPS(pageContext, workItemUrl, true);
        }

        return false;
    };
}
